import InsurerManagersService from "@/api/services/insurerManagers";
import { toCamelCase } from "@estaly/ui";

// Keywords can change while a request is still pending: only the latest request may write its results.
let latestIndexRequest = 0;

const initialState = {
  index: [],
  current: null,
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    salesManagers: (state) => state.index.filter((manager) => manager.role === "sales_manager"),
    salesManagerOptions: (_state, getters) =>
      getters.salesManagers.map((manager) => ({
        label: `${manager.firstName} ${manager.lastName}`,
        value: manager.id,
      })),
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.records || [];
      state.currentPage = data.page?.currentPage || 1;
      state.totalPages = data.page?.totalPages || 0;
      state.totalCount = data.page?.totalCount || 0;
    },

    setCurrent(state, insurerManager) {
      state.current = insurerManager;
    },
  },
  actions: {
    async fetchIndex({ commit }, params = {}) {
      const requestId = ++latestIndexRequest;
      const response = await InsurerManagersService.fetchIndex(params);
      const isLatest = requestId === latestIndexRequest;
      if (isLatest && response?.success) commit("setIndex", toCamelCase(response.data));

      return { ...response, isLatest };
    },

    async fetchShow({ commit }, id) {
      const response = await InsurerManagersService.fetchShow(id);
      if (!response?.success) return response;

      commit("setCurrent", toCamelCase(response.data));
      return response;
    },

    async create(_, params) {
      return await InsurerManagersService.create(params);
    },

    async update({ commit }, { id, ...params }) {
      const response = await InsurerManagersService.update(id, params);
      if (!response?.success) return response;

      commit("setCurrent", toCamelCase(response.data));
      return response;
    },
  },
};
